import type { NflTiebreakerTeam, TiebreakerStepFn } from '../types';
import { RankMethod } from '../../enums/rank-method';
import { createRecordPctStep } from './record-pct';

/** NFL Strength of Victory step */
export const sovStep = createRecordPctStep<NflTiebreakerTeam>(
  t => t.sov,
  RankMethod.SOV,
  'SOV',
);

/** NFL Strength of Schedule step */
export const sosStep = createRecordPctStep<NflTiebreakerTeam>(
  t => t.sos,
  RankMethod.SOS,
  'SOS',
);
